import { Typography } from '@mui/material';
import cx from 'clsx';

import styles from './ListItem.module.scss';

interface ListItemProps {
  text: string;
  variant: 'blue' | 'green' | 'orange' | 'pink';
  className?: string;
}

const ListItem = ({ text, variant, className }: ListItemProps) => (
  <Typography
    variant="body1"
    classes={{ root: styles.root }}
    className={cx(styles.container, styles[variant], className)}
  >
    {text}
  </Typography>
);

export default ListItem;
